<template>
  <div class="col-12">
    <div class="card bg-white mb-3" style="border-radius: 10px">
      <div class="card-body">
        <div id="roles-grid">
          <h3 class="mt-2">System Roles</h3>
          <BButtonToolbar class="mb-2 pt-2 border-light border-top">
            <BButtonGroup>
              <BButton
                variant="outline-primary"
                size="sm"
                @click="onAddNew"
                v-permission="'AbpIdentity.Roles.Create'"
                class="custom-button"
              >
                <font-awesome-icon icon="plus"></font-awesome-icon>
                {{ $t("systemRolesGrid.addNew") }}
              </BButton>
              <BButton
                variant="light"
                size="sm"
                @click="onDelete"
                class="ml-2"
                :disabled="datas.selected.length === 0"
                v-permission="'AbpIdentity.Roles.Delete'"
                style="background-color: #e9ecef"
              >
                {{ $t("systemRolesGrid.delete") }}
              </BButton>
            </BButtonGroup>
            <BPagination
              id="grid-pagination"
              v-model="pagination.page"
              :total-rows="datas.total"
              :per-page="pagination.maxResultCount"
              aria-controls="table"
              @update:modelValue="onPaginationChange"
              class="ml-auto"
            ></BPagination>
          </BButtonToolbar>

          <DataTable
            id="table"
            v-model:sortBy="sort.sortBy"
            :busy="isBusy"
            :fields="fields"
            :items="datas.items"
            :no-local-sorting="true"
            v-model:sort-desc.sync="sort.sortDesc"
            fixed
            hover
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            @sort-changed="onSortChanged"
            :linkFields="{ name: '/systemRoles/edit/' }"
          >
            <template #table-busy>
              <GridLoading></GridLoading>
            </template>
            <!-- A custom formatted column -->
            <template #cell(name)="data">
              <router-link :to="'/systemRoles/edit/' + data.item.id">{{ data.item.name }}</router-link>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Inject } from "inversify-props";
import { RoleApi } from "@/api";
import { IdentityRoleDto, IdentityRoleDtoPagedResultDto } from "@/api/model";
import BaseGridMixin from "@/core/views/grids/BaseGrid";
import { AxiosResponse } from "axios";
import GridLoading from "@/core/views/pages/_components/GridLoading.vue";
import { eventBus } from "@/main";
import { BButtonToolbar, BButton, BButtonGroup, BPagination, BAccordion } from "bootstrap-vue-next";
import { mixins, Options } from "vue-class-component";
import DataTable from "@/core/views/pages/_components/Table.vue";

@Options({
  components: { GridLoading, BButtonToolbar, BButton, BButtonGroup, BPagination, BAccordion, DataTable }
})
export default class SystemRolesGrid extends mixins(BaseGridMixin<IdentityRoleDto, IdentityRoleDtoPagedResultDto>) {
  @Inject("RoleApi")
  private readonly rolesApi!: RoleApi;
  name = "";
  isDefault = "";
  isPublic = "";
  isStatic = "";
  id = "";
  fields: any[] = [];
  meta = {
    formRoute: "SystemRoleFormCreate"
  };

  created(): void {
    eventBus.emit("pageName", "System Roles");
    this.name = this.$t("systemRolesGrid.name") as string;
    this.isDefault = this.$t("systemRolesGrid.isDefault") as string;
    this.isStatic = this.$t("systemRolesGrid.isStatic") as string;
    this.isPublic = this.$t("systemRolesGrid.isPublic") as string;
    this.id = this.$t("systemRolesGrid.id") as string;
    this.fields = [
      { key: "name", label: this.name, sortable: true },
      {
        key: "isDefault",
        label: this.isDefault,
        sortable: false
      },
      {
        key: "isPublic",
        label: this.isPublic,
        sortable: false
      },
      {
        key: "isStatic",
        label: this.isStatic,
        sortable: false
      },
      {
        key: "id",
        label: this.id,
        sortable: false,
        thStyle: { width: "20%" }
      }
    ];
  }

  getRequest(
    skipCount?: number,
    maxResultCount?: number,
    sorting?: string
  ): Promise<AxiosResponse<IdentityRoleDtoPagedResultDto>> {
    return this.rolesApi.apiIdentityRolesGet(undefined, sorting, skipCount, maxResultCount);
  }

  deleteRequest(id: string): Promise<AxiosResponse<void>> {
    return this.rolesApi.apiIdentityRolesIdDelete(id);
  }
}
</script>
<style scoped>
.custom-button {
  color: #0054a6;
  background-color: white;
  border-color: #0054a6;
  transition: all 0.02s ease;
}
.custom-button:hover {
  color: white !important;
  background-color: #0054a6 !important;
  border-color: #0054a6;
}
#role-form {
  font-size: 14px;
  font-family: Arial, sans-serif;
}
</style>
